import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';
import { Environment } from './environment.model';

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}
const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1 ||
  window.navigator.userAgent.indexOf('Edge') > -1;

/**
 * This file will be replaced during prod build through the prebuild.js script.
 * That way, prod setting apply for deployed versions.
 */
export const environment: Environment = {
  production: false,
  azureEndpoint: 'https://dev.api.schenck.one',
  apiBaseUrl: 'https://dev.api.schenck.one/rm/v1', // against deployed/cloud backend
  usBaseUrl: 'https://dev.api.schenck.one/user', // against deployed/cloud backend
  umBaseUrl: 'https://dev.api.schenck.one/um/v2/rights/RM', // against deployed/cloud backend
  amBaseUrl: 'https://dev.api.schenck.one/am/v1', // against deployed/cloud backend
  googleApiKey: 'AIzaSyCaCOvpgCooOPqfq4yIgpasYKr2-k9xIWQ',
  versionInfo: {
    tag: 'dev',
    hash: 'd30c8c39dd1e13a77b204eb24828a4f12b95d23a',
    buildtimestamp: '2026-10-07T09:12:13.1842935Z',
    buildVersion: '3.0.0+3931',
  },
  msalConfig: {
    msal: {
      auth: {
        clientId: '53784843-90c0-4e92-b51f-09a0e8d9bbca',
        knownAuthorities: ['durrgroupb2c.b2clogin.com'],
        authority: 'https://durrgroupb2c.b2clogin.com/durrgroupb2c.onmicrosoft.com/B2C_1A_SIGNIN',
        redirectUri: 'https://dev.rotormanager.schenck.one',
        postLogoutRedirectUri: 'https://dev.rotormanager.schenck.one/postlogout',
      },
      cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage,
        storeAuthStateInCookie: true, // set to true for IE 11. Remove this line to use Angular Universal
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Info,
          piiLoggingEnabled: false,
        },
      },
    },
    guard: {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: [
          'https://durrgroupb2c.onmicrosoft.com/ed79441b-4a58-4429-b5cd-233d0f88de57/API.All',
        ],
      },
      loginFailedRoute: '/login-failed',
    },
  },
};
